const Form069TC = {
    stepName: {
        statement: "陳述",
        information: "基本資料",
        certification: "丁部\n認證",
        confirmation: "確認",
        schoolInfo: "學校資料",
        SelectApplyType: "選擇甲部／乙部／丙部",
        sectionA: "甲部\n暫時凍結因教師休假而出現的教學人員職位空缺",
        sectionB: "乙部\n暫時凍結在核准編制內的教學人員職位",
        sectionC: "丙部\n永久凍結常額職位",
    },
    title: {
        note: "注意",
        schoolInformation: "學校資料",
        secitonATitle: "甲部	暫時凍結因教師休假而出現的教學人員職位空缺",
        secitonBTitle: "乙部	暫時凍結在核准編制內的教學人員職位",
        secitonCTitle: "丙部  永久凍結常額職位（本申請表格須包括首次及先前凍結的所有職位，以查核10%的上限）",
        secitonCTitleB: "丙部  永久凍結常額職位", // Title
        secitonDTitle: "丁部  認證",
        teachersInformation: "休假教師資料",
        calculationInformation: "整合代課教師津貼計算資料",
        officialUse: "供部門填寫",
        collectionStatement: "個人資料收集聲明",
    },
    label: {
        absenceReasonOption: {
            optionA: "(a)	有薪病假/產假/肺病特別假期",
            optionB: "(b)	有薪進修假期",
            optionC: "(c)	給予教師有薪假期，以便出任陪審員或證人",
            optionD: "(d)	其他有薪假期(請說明原因)",
            optionF: "(x)	無薪病假/產假/肺病特別假期",
            optionG: "(y)	其他無薪假期",
        },
        leaveCalendarDaysOption: {
            thirty: "30 至 89 曆日的假期",
            ninety: "90或以上曆日的假期",
        },
        vacancyCalendarDaysOption: {
            thirty: "30 至 89 曆日的假期",
            ninety: "90或以上曆日的假期",
        },
        NAMOption: {
            N: "新申領津貼的職位",
            AM: "修訂先前提出的申請（夾附副本）",
        },
        PRENEWOption: {
            PRE: "先前凍結的職位",
            NEW: "新凍結的職位",
        },
        surplusTeachersOption: {
            yes: "有過剩教師",
            no: "並沒有過剩教師",
        },
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        name: "姓名",
        SRN: "職員參考編號",
        post: "職位",
        postNumber: "職位數量",
        absenceReason: "缺勤原因",
        paidLeaveReason: "其他帶薪假期的原因",
        leavePeriodFrom: "休假時期由",
        leavePeriodTo: "休假時期至",
        periodFrom: "由",
        periodTo: "至",
        workingDays: "(a) 工作日数",
        dailyRate: "(b) 日薪率",
        monthsNo: "(c) 月份數目",
        monthlySalary: "(d) 月薪",
        MPFSubsidy: "(e) 強積金供款津貼",
        TRGAmount: "(f) 整合代課教師津貼額",
        TRGTotalAmount: "整合代課教師津貼額（總計）",
        postsClaimedNo: "申領津貼的職位數目",
        postsClaimedNoSectionC: "(a)申領津貼的職位數目",
        rank: "職級",
        NAM: "新申領津貼的職位／修訂先前提出的申請(夾附副本）",
        attachment: "副本",
        PRENEW: "先前凍結的職位／新凍結的職位",
        Date: "先前提出申請的日期",
        effectiveDate: "生效日期",
        monthlyEffectiveDate:
            "(a) 生效日期計的每月中點薪金（只適用於新凍結職位）",
        frozenMPFSubsidy: "(b) 強積金供款津貼（只適用於新凍結職位）",
        frozenTRGAmount: "(c) 新凍結職位的整合代課教師津貼額",
        frozenPostsTotal: "休假教師",
        frozenPostsArising: "暫時凍結職位",
        approvedTeaching: "在核准編制內的教學人員職位",
        frozenRegularPosts: "永久凍結常額職位",
        total: "總計",
        surplusTeachers: "過剩教師",
        surplusTeachersNo: "過剩教師數量",
        contactPerson: "聯絡人",
        telNo: "電話號碼",
        SSDO: "高級學校發展主任",
        required: "必須填寫",
        select: "請選擇你想要填寫的部分：",
        supervisorName: "校監／校長姓名",
        mpfAttachment: "強積金供款副本",
        termsConditions: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamStatement: "本人明白需透過「智方便+」帳戶以辧理申請。",
    },
    message: {
        toMessage: "致: 教育局經常津貼組",
        attnMessage: "[經辦人︰一級會計主任(經常津貼)]",
    },
    note: {
        importantNote1:
            "請提交電子表格或紙質表格，請注意，如果提交了重複的申請，處理過程可能會受影響。",
        importantNote2:
            "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出",
        importantNote3: "",
        note1: "1.	 請填寫休假教師的職員參考編號。",
        note2: "2.	 請填寫以下列字母標明缺勤原因─",
        note3: "(a) 有薪病假/產假/肺病特別假期；",
        note4: "(b) 有薪進修假期；",
        note5: "(c) 有薪進修假期(學校如有一位或多於一位教師修讀指定的專業進修課程而為期達30個連續曆日或以上)，請註明課程編號；",
        note6: "(d) 給予教師有薪假期，以便出任陪審員或證人；",
        note6b: "(e)	有薪侍產假#",
        note6c: "(f)	其他有薪假期(請說明原因)；",
        note7: "(x) 無薪病假/產假/肺病特別假期；",
        note8: "(y) 其他無薪假期。",
        note9: "學校必須按照教育局通告第1/2006號以及第16/2015號(侍產假適用)的規定批假",
        note10: "3.	 工作日數不包括週日、週六（短週、公眾假期、酌情假期或任何教師無需履行職責的日子。",
        note11: "4.	 有關資助學校代課教師的現行每日工資標準，請參閱教育局相關通函。至於代課教師標準每日工資標準和各種凍結費用的實際數額，在按照公務員薪酬調整。",
        note12: "5.	 基本職級以臨時教師的平均月薪點或晉升職級的起薪點。計算可選現金津貼的平均月薪點將每3年檢討一次，並在必要時進行修訂。有關各職級的平均月薪點數，請參閱教育局網頁的TRG指引 ",
        note12b:
            "http://www.edb.gov.hk/tc/sch-admin/fin-management/subsidy-info/trg/index.html",
        note12c: "。",
        note13: "6.	如代課期少於60個曆日，但代課教師須向強積金供款，請提供證明資料。",
        note14: "7.	 凍結的教職不包括校長／班主任、英語母語教師、學生輔導教師、小學課程負責人、特殊教育需要協調員和特殊教育需要支持教師。",
        certificationNote1: "本人證實*–",
        certificationNote2:
            "本校的法團校董會已同意於上述學年期間凍結上述教職；",
        certificationNote3:
            "本校沒有就上述乙部及丙部的職位空缺向教育局申領薪金津貼；",
        certificationNote4: {
            note1: "申領整合代課教師津貼的凍結職位總數",
            note2: "，包括(甲部)休假教師",
            note3: "和(乙部)在核准編制內的教學人員職位",
            note4: "的暫時凍結職位，以及(丙部)永久凍結常額職位",
            note5: "。這些凍結職位於申請當日並無超逾本校的核准教師編制總額(總數︰",
            note6: ") 10%的上限，",
            note7: "而",
            note8: "本申請亦符合整合代課教師津貼所訂明的所有申請條件",
            note9: "(請於空位內填上職位數目)；",
        },
        certificationNote5: {
            note1: "本校",
            note2: "名，在暫時凍結因教師休假而出現的教學人員職位空缺前，過剩教師數目已經抵銷；",
            note3: "，在暫時凍結因教師休假而出現的教學人員職位空缺前，過剩教師數目已經抵銷；",
        },
        certificationNote6:
            "本校沒有就上述假期/職缺/凍結職位期間向政府申請或領取其他額外津貼，例如以現金津貼取代額外英語教師職位及把小數位教師職位轉為小數位職位現金津貼等；以及",
        certificationNote7:
            "除上述(iv)項有過剩教師的情況外，本校已凍結的教師職位總數和受聘的常額教師數目的總和在任何時段不會超逾已核准的教學人員編制。",
        certificationNote8: "本校會把教育局多付的津貼退還。",
        statementNote: {
            note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            note2: "(a) 辦理與聘用有關的事宜；",
            note3: "(b) 處理發放薪金津貼及其他政府資助；",
            note4: "(c) 計算公積金的供款；",
            note5: "(d) 進行核數工作；",
            note6: "(e) 進行研究及統計資料，以便規劃教育服務；",
            note7: "(f) 處理有關教育專業人員發展的事宜；",
            note8: "(g) 執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
            note9: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
            note10: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
            note11: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
            note12: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
        },
    },
    order: ["(i)", "(ii)", "(iii)", "(iv)", "(v)", "(vi)"],
    tooltip: {
        tooltip1: "請填寫休假教師的職員參考編號。",
        tooltip2:
            "請注意︰學校必須按照教育局通告第1/2006號及第16/2018號的規定批核假期。",
        tooltip3:
            "工作日數不應包括星期日、星期六(短周)、公眾假期、由學校自行訂定的假期或教師毋須執行職務的任何周日。",
        tooltip4:
            "有關資助學校代課教師當時適用的日薪率，請參閱相關的教育局通函。代課教師標準日薪及用以凍結職位的各項津貼額的實際金額，會根據公務員薪酬調整。",
        tooltip5a:
            "基本職級以臨時教師的平均每月薪點計算，晉升職級以該職級的起薪點計算。用以計算可供選擇現金津貼的平均月薪點將每三年檢討一次，並在有需要時予以修訂。相關職級的平均月薪點可參考在教育局網頁內有關整合代課教師津貼的指引(網址為：",
        tooltip5b:
            "http://www.edb.gov.hk/tc/sch-admin/fin-management/subsidy-info/trg/index.html",
        tooltip5c: ")。",
        tooltip6:
            "如凍結出缺教職達60天或以上，將包括強積金計劃僱主供款(月薪的5%或1,500元，取其較少者)。",
        tooltip7:
            "可凍結的教師職位不包括校長、以英語為母語的英語教師、學生輔導教師、小學課程統籌主任、特殊教育需要統籌主任及特殊教育需要支援老師職位。",
        tooltipCTitle:
            "本申請表格須包括首次及先前凍結的所有職位，以查核10%的上限",
        tooltipC1: "PRE︰先前凍結的職位 / NEW︰新凍結的職位",
        tooltipC2:
            "如凍結出缺教職達60天或以上，將包括強積金計劃僱主供款(月薪的5%或1,500元，取其較少者)",
    },
    SSDOValue: {
        0: "北區",
        1: "葵青區",
        2: "西貢區",
        3: "東區",
        4: "屯門區",
        5: "九龍城區",
        6: "觀塘區",
        7: "南區",
        8: "油尖旺區",
        9: "荃灣區",
        10: "沙田區",
        11: "深水埗區",
        12: "大埔區",
        13: "灣仔區",
        14: "離島區",
        15: "中西區",
        16: "元朗區",
        17: "黃大仙區",
    },
    errorMsg: {
        least30Days: "時期少於30曆日，請重新選擇。",
        "E-001": "僅允許包含英文字符、空格、點、逗號、連字符和單引號。",
        "E-002": "請選擇最少1項",
    },
};
export default Form069TC;
